import React from "react";
import type { Language, LocalizedText } from "../../components/ui/LanguageProvider";
// ★ 274KB 번역 사전은 static import 하지 않는다(그러면 eager main.js 에 상주 → /login·/home 도 다운로드).
//   CRM 진입(이 컴포넌트 마운트) 시 동적 import 로만 로드한다. 로드 전에는 사전 없이(=원문 그대로) 렌더 →
//   KO 모드는 원문이 정답이라 무변화, EN 모드는 사전 도착까지 잠깐 원문 노출 후 자동 재번역(회귀 없음, 타이밍만 지연).

type TextState = {
  source: string;
  last: string;
};

type AttrState = {
  source: string;
  last: string;
};

const TEXT_STATE = new WeakMap<Text, TextState>();
const ATTR_STATE = new WeakMap<Element, Map<string, AttrState>>();
const TRANSLATABLE_ATTRS = ["title", "aria-label", "placeholder"];
const PHRASE_TRANSLATIONS: LocalizedText[] = [
  { ko: "개발 중", en: "In Development" },
  { ko: "사용 가이드", en: "User Guide" },
  { ko: "화면으로 이동", en: "Go to Page" },
  { ko: "진행 중 Opportunity", en: "Open Opportunities" },
  { ko: "초도 미팅", en: "Initial Meeting" },
  { ko: "현황 분석", en: "Current-State Analysis" },
  { ko: "ROI 분석", en: "ROI Analysis" },
  { ko: "3D 시뮬레이션", en: "3D Simulation" },
  { ko: "제안서 제출", en: "Proposal Submitted" },
  { ko: "견적서 제출", en: "Quote Submitted" },
  { ko: "계약 협의", en: "Contract Negotiation" },
  { ko: "계약 체결", en: "Contract Signed" },
  { ko: "프로젝트 킥오프", en: "Project Kickoff" },
  { ko: "영업 실패", en: "Lost" },
  { ko: "리스크 현황", en: "Risk Status" },
  { ko: "정체 Deal", en: "Stalled Deals" },
  { ko: "가중 매출 Forecast", en: "Weighted Revenue Forecast" },
  { ko: "ROI 분석 단계", en: "ROI Analysis Stage" },
  { ko: "전체 파트너", en: "All Partners" },
  { ko: "매핑 파트너", en: "Mapped Partners" },
  { ko: "매핑 구성요소", en: "Mapped Components" },
  { ko: "활성 매핑", en: "Active Mappings" },
  { ko: "파트너 정보", en: "Partner Data" },
  { ko: "건수", en: "Count" },
  { ko: "미팅 유형", en: "Meeting Type" },
  { ko: "최근 30일", en: "Last 30 Days" },
  { ko: "매핑 운영 현황", en: "Mapping Operations" },
  { ko: "전체 기간", en: "All Time" },
  { ko: "포함 패키지 수", en: "Included Packages" },
  { ko: "패키지 구성요소 포함 수", en: "Included Package Components" },
  { ko: "Lead 요청 패키지", en: "Lead Requested Packages" },
  { ko: "생성 월", en: "Created Month" },
  { ko: "가중 금액", en: "Weighted Amount" },
  { ko: "영업 프로젝트", en: "Sales Project" },
  { ko: "영업 파이프라인", en: "Sales Pipeline" },
  { ko: "기본", en: "Default" },
  { ko: "WMS 구독", en: "WMS Subscription" },
  { ko: "신규 기회", en: "New Opportunity" },
  { ko: "고객 정보", en: "Customer Info" },
  { ko: "단계 이동", en: "Move Stage" },
  { ko: "플로우 빌더", en: "Flow Builder" },
  { ko: "낮음", en: "Low" },
  { ko: "중간", en: "Medium" },
  { ko: "높음", en: "High" },
  { ko: "미지정", en: "Unassigned" },
  { ko: "단계", en: "Steps" },
  { ko: "현재", en: "Current" },
  { ko: "검증", en: "Validation" },
  { ko: "제안", en: "Proposal" },
  { ko: "협상", en: "Negotiation" },
  { ko: "수주", en: "Won" },
  { ko: "선택 안함", en: "None" },
  { ko: "선택 안 함", en: "None" },
  { ko: "도입 검토", en: "Implementation Review" },
  { ko: "PoC 상담", en: "PoC Consultation" },
  { ko: "데모센터 예약", en: "Demo Center Booking" },
  { ko: "일반 문의", en: "General Inquiry" },
  { ko: "POC 상담", en: "PoC Consultation" },
  { ko: "유지보수 문의", en: "Maintenance Inquiry" },
  { ko: "요약 / 인사이트", en: "Summary / Insight" },
  { ko: "담당자", en: "Owner" },
  { ko: "내부 메모", en: "Internal Memo" },
  { ko: "전화번호", en: "Phone Number" },
  { ko: "일정 / 활동", en: "Schedule / Activity" },
  { ko: "자료/첨부", en: "Files / Attachments" },
  { ko: "확인 메일 재발송", en: "Resend Confirmation Email" },
  { ko: "견적서 작성기", en: "Quote Builder" },
  { ko: "견적 이력", en: "Quote History" },
  { ko: "저장 제목", en: "Save Title" },
  { ko: "현재 내용 저장", en: "Save Current Content" },
  { ko: "저장된 이력이 없습니다.", en: "No saved history." },
  { ko: "견적서 정보", en: "Quote Information" },
  { ko: "견적서 제목", en: "Quote Title" },
  { ko: "발송일", en: "Sent Date" },
  { ko: "유효기간", en: "Validity Period" },
  { ko: "기본 선택", en: "Default Selection" },
  { ko: "시스템", en: "System" },
  { ko: "기타", en: "Other" },
  { ko: "통화", en: "Currency" },
  { ko: "지급 조건", en: "Payment Terms" },
  { ko: "월별 분할지급", en: "Monthly Installments" },
  { ko: "분기별 지급", en: "Quarterly Payment" },
  { ko: "연간 일시불", en: "Annual Lump Sum" },
  { ko: "플랜", en: "Plan" },
  { ko: "표준 SaaS 도입형", en: "Standard SaaS Implementation" },
  { ko: "운영 확장형", en: "Operations Expansion" },
  { ko: "고객 맞춤 협의형", en: "Custom Negotiated" },
  { ko: "계약 시작일", en: "Contract Start Date" },
  { ko: "계약 종료일", en: "Contract End Date" },
  { ko: "DB에서 불러오기", en: "Load from DB" },
  { ko: "파트너 선택 시 자동 입력", en: "Auto-fill on Partner Selection" },
  { ko: "선택", en: "Select" },
  { ko: "고객사명", en: "Customer Company" },
  { ko: "대표자", en: "Representative" },
  { ko: "사업자번호", en: "Business Registration No." },
  { ko: "서명 이메일", en: "Signature Email" },
  { ko: "주소", en: "Address" },
  { ko: "견적 구성", en: "Quote Items" },
  { ko: "행 추가", en: "Add Row" },
  { ko: "항목", en: "Item" },
  { ko: "내역", en: "Description" },
  { ko: "서비스", en: "Service" },
  { ko: "가격유형", en: "Price Type" },
  { ko: "가격", en: "Price" },
  { ko: "금액", en: "Amount" },
  { ko: "단위", en: "Unit" },
  { ko: "비고", en: "Note" },
  { ko: "고정", en: "Fixed" },
  { ko: "단위별", en: "Per Unit" },
  { ko: "협의", en: "Negotiable" },
  { ko: "제외", en: "Excluded" },
  { ko: "검토", en: "Review" },
  { ko: "한글", en: "Korean" },
  { ko: "연결", en: "Linked" },
  { ko: "인쇄", en: "Print" },
  { ko: "3D 미리보기", en: "3D Preview" },
  { ko: "비교", en: "Compare" },
  { ko: "준비됨", en: "Ready" },
  { ko: "전체 삭제", en: "Clear All" },
  { ko: "시뮬레이션", en: "Simulation" },
  { ko: "설비", en: "Equipment" },
  { ko: "입출고", en: "Inbound / Outbound" },
  { ko: "입고 도크", en: "Inbound Dock" },
  { ko: "출고 도크", en: "Outbound Dock" },
  { ko: "입고", en: "Inbound" },
  { ko: "출고", en: "Outbound" },
  { ko: "이송", en: "Transport" },
  { ko: "컨베이어", en: "Conveyor" },
  { ko: "보관", en: "Storage" },
  { ko: "처리", en: "Processing" },
  { ko: "포장", en: "Packing" },
  { ko: "처리량", en: "Throughput" },
  { ko: "가동률", en: "Utilization" },
  { ko: "리드타임", en: "Lead Time" },
  { ko: "여유 있음", en: "Has Buffer" },
  { ko: "병목 없음", en: "No Bottleneck" },
  { ko: "구성 검증", en: "Layout Validation" },
  { ko: "추천 개선안", en: "Recommendations" },
  { ko: "부족", en: "Shortage" },
  { ko: "피크 여유 없음", en: "No Peak Buffer" },
  { ko: "과잉 사양 검토", en: "Review Oversized Spec" },
  { ko: "설비 열기", en: "Open Equipment" },
  { ko: "목표", en: "Target" },
  { ko: "단순 회수기간", en: "Simple Payback Period" },
  { ko: "단순 ROI", en: "Simple ROI" },
];
// 항상 스킵(편집영역·미디어) — 마커가 있어도 번역하지 않는다.
const ALWAYS_SKIP_SELECTOR = [
  "[data-crm-i18n-skip='true']",
  "[contenteditable='true']",
  "iframe",
  "pre",
  "code",
].join(",");
// 문서 표면 스킵 — 기본은 스킵하지만, 조상에 [data-doc-i18n='on'] 이 있으면 예외적으로 번역한다.
//  (견적서 문서를 영문화하려고 견적 미리보기/인쇄 루트에만 마커를 단다. 제안서·계약서·NDA 등은 마커가 없어 그대로 스킵.)
const DOC_SKIP_SELECTOR = [
  "[data-doc-surface]",
  ".doc-preview-stage",
  ".doc-preview-zoom-wrap",
  ".document-print-root",
  ".proposal-print-root",
  ".proposal-preview-shell",
].join(",");

function isSkipped(element: Element | null): boolean {
  if (!element) return true;
  if (element.closest(ALWAYS_SKIP_SELECTOR)) return true;
  if (element.closest(DOC_SKIP_SELECTOR)) return !element.closest("[data-doc-i18n]"); // 마커(on|dates)가 있으면 예외
  return false;
}

// 문서 i18n 마커 레벨: "on"=전체 번역, "dates"=날짜/카운트만(법률문서 조항 보존), null=마커 없음.
function docI18nMode(element: Element | null): "on" | "dates" | null {
  const marker = element?.closest("[data-doc-i18n]");
  const v = marker?.getAttribute("data-doc-i18n");
  return v === "dates" ? "dates" : v ? "on" : null;
}

function makeMap(language: Language, entries: LocalizedText[]) {
  const map = new Map<string, string>();
  entries.forEach((entry) => {
    map.set(entry.ko, entry[language]);
    map.set(entry.en, entry[language]);
  });
  return map;
}

function translateByPrefix(source: string, language: Language, entries: LocalizedText[]) {
  for (const entry of entries) {
    const from = language === "en" ? entry.ko : entry.en;
    const to = entry[language];
    if (source.startsWith(from)) return `${to}${source.slice(from.length)}`;
  }
  return source;
}

function translateByPhrase(source: string, language: Language) {
  const entry = PHRASE_TRANSLATIONS.find((item) => {
    const from = language === "en" ? item.ko : item.en;
    return source === from;
  });
  return entry ? entry[language] : source;
}

function translateCompositeExact(source: string, dictionary: Map<string, string>) {
  if (source.includes("\t")) {
    const parts = source.split("\t");
    const translated = parts.map((part) => dictionary.get(part.trim()) ?? part);
    if (translated.some((part, index) => part !== parts[index])) return translated.join("\t");
  }

  if (source.includes(" · ")) {
    const parts = source.split(" · ");
    const translated = parts.map((part) => dictionary.get(part.trim()) ?? part);
    if (translated.some((part, index) => part !== parts[index])) return translated.join(" · ");
  }

  const colonMatch = source.match(/^(.+?):\s*(.+)$/);
  if (colonMatch) {
    const label = colonMatch[1].trim();
    const value = colonMatch[2].trim();
    const translatedLabel = dictionary.get(label);
    const translatedValue = dictionary.get(value);
    // 라벨·값 어느 쪽이든 사전에 있으면 각각 번역 — "유형: 외부 유입" 류의 값 부분 미번역 해소
    if (translatedLabel || translatedValue) return `${translatedLabel ?? label}: ${translatedValue ?? colonMatch[2]}`;
  }

  const parenCountMatch = source.match(/^(.+?)\s+\(([0-9,]+)\)$/);
  if (parenCountMatch) {
    const label = parenCountMatch[1].trim();
    const translatedLabel = dictionary.get(label);
    if (translatedLabel) return `${translatedLabel} (${parenCountMatch[2]})`;
  }

  const koreanCountMatch = source.match(/^(.+?)\s+([0-9,]+)개$/);
  if (koreanCountMatch) {
    const label = koreanCountMatch[1].trim();
    const translatedLabel = dictionary.get(label);
    if (translatedLabel) return `${translatedLabel} ${formatEnglishCount(koreanCountMatch[2], "items")}`;
  }

  const ratioCountMatch = source.match(/^(.+?)\s+([0-9,]+\/[0-9,]+)개$/);
  if (ratioCountMatch) {
    const label = ratioCountMatch[1].trim();
    const translatedLabel = dictionary.get(label);
    if (translatedLabel) return `${translatedLabel} ${ratioCountMatch[2]}`;
  }

  const datedStatusMatch = source.match(/^(.+?)\s+(\d{4}-\d{2}-\d{2})$/);
  if (datedStatusMatch) {
    const label = datedStatusMatch[1].trim();
    const translatedLabel = dictionary.get(label);
    if (translatedLabel) return `${translatedLabel} ${datedStatusMatch[2]}`;
  }

  const projectSuffixMatch = source.match(/^(.+?) - 영업 프로젝트(.*)$/);
  if (projectSuffixMatch) return normalizeEnglishTimeMarkers(`${projectSuffixMatch[1]} - Sales Project${projectSuffixMatch[2]}`);

  // 구조화 이름(2026-10-07, lib/project-name.js) — "고객사(지역) - 솔루션 목적" 의 목적·「물류」만 영문으로(고객사·지역·솔루션명은 그대로)
  const structuredNameMatch = source.match(/^(.+? - )(?:(.*?) )?(신규 구축|고도화|확장|교체|자동화 도입|컨설팅|유지보수)$/);
  if (structuredNameMatch) {
    const PURPOSE_EN: Record<string, string> = { "신규 구축": "New build", "고도화": "Upgrade", "확장": "Expansion", "교체": "Replacement", "자동화 도입": "Automation rollout", "컨설팅": "Consulting", "유지보수": "Maintenance" };
    const solution = structuredNameMatch[2] === "물류" ? "Logistics" : structuredNameMatch[2];
    return `${structuredNameMatch[1]}${solution ? `${solution} ` : ""}${PURPOSE_EN[structuredNameMatch[3]]}`;
  }

  const logConnectingMatch = source.match(/^\[(.+?)\] 연결 시도\.\.\.$/);
  if (logConnectingMatch) return `[${normalizeEnglishTimeMarkers(logConnectingMatch[1])}] Connecting...`;

  const logCustomerModeMatch = source.match(/^\[(.+?)\] 고객 목록 모드 — 스키마 조회 생략$/);
  if (logCustomerModeMatch) return `[${normalizeEnglishTimeMarkers(logCustomerModeMatch[1])}] Customer list mode — skipping schema lookup`;

  const logCustomerLoadedMatch = source.match(/^\[(.+?)\] 고객 ([0-9,]+)명 로드됨$/);
  if (logCustomerLoadedMatch) return `[${normalizeEnglishTimeMarkers(logCustomerLoadedMatch[1])}] Loaded ${logCustomerLoadedMatch[2]} customers`;

  const wonAmountMatch = source.match(/^([0-9,]+)원$/);
  if (wonAmountMatch) return `KRW ${wonAmountMatch[1]}`;

  const linkedCountMatch = source.match(/^([0-9,]+)건 연결됨(.+)$/);
  if (linkedCountMatch) return `${linkedCountMatch[1]} linked${linkedCountMatch[2]}`;

  const numericKoreanCount = source.match(/^([0-9,]+)개$/);
  if (numericKoreanCount) return formatEnglishCount(numericKoreanCount[1], "items");

  const numericKoreanCaseCount = source.match(/^([0-9,]+)건$/);
  if (numericKoreanCaseCount) return formatEnglishCount(numericKoreanCaseCount[1], "items");

  const numericKoreanPerHour = source.match(/^([0-9,]+)개\/hr$/);
  if (numericKoreanPerHour) return `${numericKoreanPerHour[1]}/hr`;

  const koreanTenThousandAmount = source.match(/^([0-9,]+(?:\.[0-9]+)?)만$/);
  if (koreanTenThousandAmount) {
    // 1만 = 10,000 KRW → 100만 = 1M. 만 을 백만(M) 단위로 환산.
    const man = parseFloat(koreanTenThousandAmount[1].replace(/,/g, ""));
    return Number.isFinite(man) ? `KRW ${(man / 100).toLocaleString("en-US", { maximumFractionDigits: 1 })}M` : `KRW ${koreanTenThousandAmount[1]}만`;
  }

  const koreanHundredMillionAmount = source.match(/^([0-9,]+(?:\.[0-9]+)?)억$/);
  if (koreanHundredMillionAmount) {
    // ★ 기존 버그: `${x}00M` 문자열 이어붙이기 → "29.6억"이 "29.600M"(100배 축소)로 표기됐다.
    //   1억 = 0.1B KRW. 10억 이상은 B, 미만은 백만(M) 단위로 정확히 환산한다.
    const eok = parseFloat(koreanHundredMillionAmount[1].replace(/,/g, ""));
    if (!Number.isFinite(eok)) return `KRW ${koreanHundredMillionAmount[1]}억`;
    return eok >= 10
      ? `KRW ${(eok / 10).toLocaleString("en-US", { maximumFractionDigits: 2 })}B`
      : `KRW ${Math.round(eok * 100).toLocaleString("en-US")}M`;
  }

  const dtwinCapaShortageTitle = source.match(/^(.+) — CAPA 부족$/);
  if (dtwinCapaShortageTitle) return `${dictionary.get(dtwinCapaShortageTitle[1]) ?? dtwinCapaShortageTitle[1]} — CAPA Shortage`;

  const dtwinNoPeakTitle = source.match(/^(.+) — 피크 여유 없음$/);
  if (dtwinNoPeakTitle) return `${dictionary.get(dtwinNoPeakTitle[1]) ?? dtwinNoPeakTitle[1]} — No Peak Buffer`;

  const dtwinOversizedTitle = source.match(/^(.+) — 과잉 사양 검토$/);
  if (dtwinOversizedTitle) return `${dictionary.get(dtwinOversizedTitle[1]) ?? dtwinOversizedTitle[1]} — Review Oversized Spec`;

  const dtwinShortageBody = source.match(/^현재 ([0-9,]+)\/hr, 목표 ([0-9,]+)\/hr보다 ([0-9,]+)\/hr 부족\. 최소 ([0-9,]+)\/hr으로 증설하면 ([0-9,]+)% 여유가 생깁니다\.$/);
  if (dtwinShortageBody) {
    return `Current ${dtwinShortageBody[1]}/hr, short by ${dtwinShortageBody[3]}/hr against target ${dtwinShortageBody[2]}/hr. Increase to at least ${dtwinShortageBody[4]}/hr to secure ${dtwinShortageBody[5]}% buffer.`;
  }

  const dtwinSetCapa = source.match(/^([0-9,]+)\/hr 설정$/);
  if (dtwinSetCapa) return `Set ${dtwinSetCapa[1]}/hr`;

  const dtwinPeakBody = source.match(/^현재 ([0-9,]+)\/hr로 목표를 충족하지만 ([0-9,]+)% 안전 마진이 없습니다\. 피크 시 병목이 발생할 수 있습니다\.$/);
  if (dtwinPeakBody) {
    return `Current ${dtwinPeakBody[1]}/hr meets the target, but lacks a ${dtwinPeakBody[2]}% safety margin. A bottleneck may occur during peak periods.`;
  }

  const dtwinOversizedBody = source.match(/^현재 ([0-9,]+)\/hr로 목표 대비 ([0-9,]+)% 초과\. 하위 사양으로 교체하면 비용을 절감할 수 있습니다\.$/);
  if (dtwinOversizedBody) {
    return `Current ${dtwinOversizedBody[1]}/hr exceeds the target by ${dtwinOversizedBody[2]}%. Switching to a lower spec can reduce cost.`;
  }

  return source;
}

function normalizeEnglishTimeMarkers(source: string) {
  return source.replace(/오전/g, "AM").replace(/오후/g, "PM");
}

const EN_MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const monthOk = (n: number) => n >= 1 && n <= 12;
// EN 모드: 한국식 날짜(toLocaleDateString('ko-KR')="2026. 8. 11." / "2026년 8월 11일" 등)를 영문으로.
//  한글이 없는 "2026. 8. 11." 형식은 사전으로 못 바꾸므로 여기서 처리한다.
function reformatKoreanDate(source: string): string | null {
  let m: RegExpMatchArray | null;
  m = source.match(/^(\d{4})\.\s*(\d{1,2})\.\s*(\d{1,2})\.?$/); // 2026. 8. 11.
  if (m && monthOk(+m[2])) return `${EN_MONTHS[+m[2] - 1]} ${+m[3]}, ${m[1]}`;
  m = source.match(/^(\d{4})년\s*(\d{1,2})월\s*(\d{1,2})일$/); // 2026년 8월 11일
  if (m && monthOk(+m[2])) return `${EN_MONTHS[+m[2] - 1]} ${+m[3]}, ${m[1]}`;
  m = source.match(/^(\d{1,2})월\s*(\d{1,2})일$/); // 8월 11일
  if (m && monthOk(+m[1])) return `${EN_MONTHS[+m[1] - 1]} ${+m[2]}`;
  m = source.match(/^(\d{4})년\s*(\d{1,2})월$/); // 2026년 8월
  if (m && monthOk(+m[2])) return `${EN_MONTHS[+m[2] - 1]} ${m[1]}`;
  m = source.match(/^(\d{4})년$/); // 2026년
  if (m) return `${m[1]}`;
  return null;
}

// EN 모드: 파이프라인/카드의 한국어 카운트 문구.
function reformatKoreanCounts(source: string): string | null {
  let m: RegExpMatchArray | null;
  m = source.match(/^진행\s*중\s*([0-9,]+)건$/); if (m) return `${m[1]} in progress`;
  m = source.match(/^보류\s*([0-9,]+)건\s*제외$/); if (m) return `Excl. ${m[1]} on-hold`;
  m = source.match(/^전체의\s*([0-9,]+)%$/); if (m) return `${m[1]}% of total`;
  m = source.match(/^보유\s*기술\s*:\s*([0-9,]+)개$/); if (m) return `Owned tech: ${m[1]}`;
  m = source.match(/^미설정\s*([0-9,]+)개$/); if (m) return `${m[1]} unset`;
  m = source.match(/^미설정\s*([0-9,]+)$/); if (m) return `${m[1]} unset`;
  return null;
}

function isZeroCount(value: string) {
  return Number(value.replace(/,/g, "")) === 0;
}

function formatEnglishCount(value: string, unit: "items" | "leads" | "batches") {
  // 'items' 카운트는 단위 없이 숫자만 표기(사용자 요청: 카드 곳곳의 'N items' 노이즈 제거).
  //  leads/batches 등 의미 있는 단위는 유지하되 0일 때는 단위 생략.
  if (unit === "items") return value;
  return isZeroCount(value) ? value : `${value} ${unit}`;
}

function normalizeBareZeroQuantity(source: string) {
  const compact = source.match(/^([0-9,]+)items(?:\/hr)?$/);
  if (compact) return compact[1];

  const bare = source.match(/^([0-9,]+)\s+(items|leads|batches)$/i);
  if (bare && isZeroCount(bare[1])) return bare[1];

  return source;
}

function normalizeZeroQuantityEnglish(source: string) {
  const labeled = source.match(/^(.+?)\s+([0-9,]+)\s+(items|leads|batches)$/i);
  if (labeled && isZeroCount(labeled[2])) return `${labeled[1]} ${labeled[2]}`;

  return source;
}

function translateCore(source: string, language: Language, dictionary: Map<string, string>) {
  const normalizedBareZeroQuantity = normalizeBareZeroQuantity(source);
  if (normalizedBareZeroQuantity !== source) return normalizedBareZeroQuantity;

  if (language === "en") {
    const normalizedZeroQuantity = normalizeZeroQuantityEnglish(source);
    if (normalizedZeroQuantity !== source) return normalizedZeroQuantity;
    const dateEn = reformatKoreanDate(source);
    if (dateEn) return dateEn;
    const countEn = reformatKoreanCounts(source);
    if (countEn) return countEn;
  }

  if (dictionary.has(source)) return dictionary.get(source) ?? source;

  const composite = translateCompositeExact(source, dictionary);
  if (composite !== source) return composite;

  const countPatterns: Array<{ ko: RegExp; en: RegExp; koText: (match: RegExpMatchArray) => string; enText: (match: RegExpMatchArray) => string }> = [
    {
      ko: /^전체\s+([0-9,]+)건$/,
      en: /^All\s+([0-9,]+)\s+items$/,
      koText: (match) => `전체 ${match[1]}건`,
      enText: (match) => `All ${formatEnglishCount(match[1], "items")}`,
    },
    {
      ko: /^([0-9,]+)건\s+선택$/,
      en: /^([0-9,]+)\s+selected$/,
      koText: (match) => `${match[1]}건 선택`,
      enText: (match) => `${match[1]} selected`,
    },
    {
      ko: /^Lead\s+([0-9,]+)건$/,
      en: /^([0-9,]+)\s+leads$/,
      koText: (match) => `Lead ${match[1]}건`,
      enText: (match) => formatEnglishCount(match[1], "leads"),
    },
    {
      ko: /^외부\s+([0-9,]+)건$/,
      en: /^External\s+([0-9,]+)\s+items$/,
      koText: (match) => `외부 ${match[1]}건`,
      enText: (match) => `External ${formatEnglishCount(match[1], "items")}`,
    },
    {
      ko: /^기술 구성 \(([0-9,]+)개 선택\)$/,
      en: /^Technology Configuration \(([0-9,]+) selected\)$/,
      koText: (match) => `기술 구성 (${match[1]}개 선택)`,
      enText: (match) => `Technology Configuration (${match[1]} selected)`,
    },
  ];

  for (const pattern of countPatterns) {
    const koMatch = source.match(pattern.ko);
    if (koMatch) return language === "ko" ? pattern.koText(koMatch) : pattern.enText(koMatch);
    const enMatch = source.match(pattern.en);
    if (enMatch) return language === "ko" ? pattern.koText(enMatch) : pattern.enText(enMatch);
  }

  const prefixEntries: LocalizedText[] = [
    { ko: "Opportunity: ", en: "Opportunity: " },
    { ko: "Lead: ", en: "Lead: " },
    { ko: "Step: ", en: "Step: " },
    { ko: "저장 대상: ", en: "Save Target: " },
    { ko: "완료: ", en: "Completed: " },
    { ko: "조회 실패: ", en: "Lookup Failed: " },
    { ko: "정상 실행: ", en: "Run Succeeded: " },
    { ko: "위젯 삭제 실패: ", en: "Failed to delete widget: " },
    { ko: "위젯 순서 저장 실패: ", en: "Failed to save widget order: " },
    { ko: "담당: ", en: "Owner: " },
    { ko: "담당자: ", en: "Contact Person: " },
    { ko: "파트너 목록 (", en: "Partner List (" },
    { ko: "보유 기술 항목 가중치 (", en: "Owned Technology Item Weights (" },
    { ko: "미설정 ", en: "Unset " },
    { ko: "기술 일치 ", en: "Technology Matches " },
    { ko: "최초 ", en: "First " },
    { ko: "수신: ", en: "Recipient: " },
    { ko: "→ 현재: ", en: "→ Current: " },
    { ko: "현재: ", en: "Current: " },
    { ko: "개선: ", en: "Improved: " },
  ];

  const prefixed = translateByPrefix(source, language, prefixEntries);
  if (prefixed !== source) return prefixed;

  if (language === "en" && /[0-9]/.test(source) && /오전|오후/.test(source)) {
    return normalizeEnglishTimeMarkers(source);
  }

  return translateByPhrase(source, language);
}

function splitOuterWhitespace(value: string) {
  const match = value.match(/^(\s*)([\s\S]*?)(\s*)$/);
  return {
    before: match?.[1] ?? "",
    core: match?.[2] ?? value,
    after: match?.[3] ?? "",
  };
}

function getTextSource(node: Text, core: string) {
  const state = TEXT_STATE.get(node);
  if (!state || (core !== state.source && core !== state.last)) {
    return core;
  }
  return state.source;
}

function setTextTranslation(node: Text, before: string, source: string, translated: string, after: string) {
  const nextValue = `${before}${translated}${after}`;
  if (node.nodeValue !== nextValue) node.nodeValue = nextValue;
  TEXT_STATE.set(node, { source, last: translated });
}

function getAttrState(element: Element, attr: string) {
  let stateByAttr = ATTR_STATE.get(element);
  if (!stateByAttr) {
    stateByAttr = new Map<string, AttrState>();
    ATTR_STATE.set(element, stateByAttr);
  }
  return stateByAttr;
}

function translateAttribute(element: Element, attr: string, language: Language, dictionary: Map<string, string>) {
  if (isSkipped(element)) return;
  if (docI18nMode(element) === "dates") return; // 날짜모드 문서(법률)는 속성 사전 번역 안 함
  const value = element.getAttribute(attr);
  if (!value) return;

  const stateByAttr = getAttrState(element, attr);
  const state = stateByAttr.get(attr);
  const source = !state || (value !== state.source && value !== state.last) ? value : state.source;
  const translated = translateCore(source, language, dictionary);

  if (translated !== value) element.setAttribute(attr, translated);
  stateByAttr.set(attr, { source, last: translated });
}

function shouldSkipTextNode(node: Text) {
  const parent = node.parentElement;
  if (!parent) return true;
  const tagName = parent.tagName.toLowerCase();
  if (["script", "style", "textarea", "code", "pre"].includes(tagName)) return true;
  if (isSkipped(parent)) return true;
  return false;
}

function translateTextNode(node: Text, language: Language, dictionary: Map<string, string>) {
  if (shouldSkipTextNode(node)) return;
  const raw = node.nodeValue ?? "";
  const { before, core, after } = splitOuterWhitespace(raw);
  const lookup = core.includes("\t") ? core.trim() : core.replace(/\s+/g, " ").trim();
  if (!lookup) return;

  const source = getTextSource(node, core);
  const sourceLookup = source.includes("\t") ? source.trim() : source.replace(/\s+/g, " ").trim();
  // 날짜모드(법률문서): 날짜/카운트만 재포맷, 조항 텍스트는 그대로 둔다. 그 외: 전체 번역.
  const translated = docI18nMode(node.parentElement) === "dates"
    ? (language === "en" ? (reformatKoreanDate(sourceLookup) ?? reformatKoreanCounts(sourceLookup) ?? sourceLookup) : sourceLookup)
    : translateCore(sourceLookup, language, dictionary);
  if (translated === lookup) {
    TEXT_STATE.set(node, { source: core, last: core });
    return;
  }
  setTextTranslation(node, before, sourceLookup, translated, after);
}

function translateElement(root: HTMLElement, language: Language, dictionary: Map<string, string>) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    translateTextNode(walker.currentNode as Text, language, dictionary);
  }

  const elements = [root, ...Array.from(root.querySelectorAll("*"))];
  elements.forEach((element) => {
    TRANSLATABLE_ATTRS.forEach((attr) => translateAttribute(element, attr, language, dictionary));
  });
}

// 변경된 노드만 번역(증분) — MutationObserver 콜백에서 전체-트리 재순회 대신 사용.
function translateSubtree(node: Node, language: Language, dictionary: Map<string, string>) {
  if (node.nodeType === Node.TEXT_NODE) {
    translateTextNode(node as Text, language, dictionary);
    return;
  }
  if (node.nodeType === Node.ELEMENT_NODE) {
    translateElement(node as HTMLElement, language, dictionary);
  }
}

export default function CrmRuntimeTranslator({
  language,
  children,
}: {
  language: Language;
  children: React.ReactNode;
}) {
  const rootRef = React.useRef<HTMLDivElement | null>(null);
  // 사전은 CRM 진입 시 동적 로드. 도착 전에는 빈 배열(원문 렌더) → 도착 후 dictionary 재생성 → 아래 effect 재실행으로 전체 재번역.
  const [dictEntries, setDictEntries] = React.useState<LocalizedText[]>([]);
  React.useEffect(() => {
    let alive = true;
    import("./crmRuntimeTranslations")
      .then((m) => { if (alive) setDictEntries(m.CRM_RUNTIME_TRANSLATIONS); })
      .catch(() => { /* 로드 실패 시 원문 유지(번역만 생략, 기능 정상) */ });
    return () => { alive = false; };
  }, []);
  const dictionary = React.useMemo(() => makeMap(language, dictEntries), [language, dictEntries]);

  React.useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    let applying = false;
    let frame = 0;
    // 변경분만 모아 다음 프레임에 번역(전체-트리 재순회 제거 → CRM 화면 전환/렌더 비용 대폭 감소).
    const pending = new Set<Node>();

    const flush = () => {
      if (applying) return;
      applying = true;
      pending.forEach((node) => {
        if (node.isConnected) translateSubtree(node, language, dictionary);
      });
      pending.clear();
      applying = false;
    };

    const schedule = () => {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(flush);
    };

    // 최초 1회는 전체 패스(기존 동작 보존 — 마운트 시점의 ko/en 출력 동일).
    applying = true;
    translateElement(root, language, dictionary);
    applying = false;

    const observer = new MutationObserver((mutations) => {
      if (applying) return;
      let relevant = false;
      for (const mutation of mutations) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => { pending.add(node); relevant = true; });
        } else if (mutation.type === "characterData") {
          pending.add(mutation.target); relevant = true;
        } else if (mutation.type === "attributes" && TRANSLATABLE_ATTRS.includes(mutation.attributeName ?? "")) {
          pending.add(mutation.target); relevant = true;
        }
      }
      if (relevant) schedule();
    });

    observer.observe(root, {
      attributes: true,
      attributeFilter: TRANSLATABLE_ATTRS,
      characterData: true,
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [dictionary, language]);

  return (
    <div ref={rootRef} style={{ display: "contents" }}>
      {children}
    </div>
  );
}
